import { z } from 'zod';
import { Email, IsoDateTime } from './common.js';
/** Platform > Settings > Email server. The password is never returned: only whether one is set. */
export const EmailTransportKind = z.enum(['file', 'smtp']);
export const EmailSecurity = z.enum(['none', 'starttls', 'tls']);
/** A DNS name or an IP address. No scheme, port, path, spaces or credentials. */
export const SMTP_HOST_PATTERN = /^(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$|^\[?[0-9A-Fa-f:]+\]?$/;
export const EmailServerView = z.object({
    /** `database` = saved in the portal; `environment` = nothing saved yet, the server's environment variables apply. */
    source: z.enum(['database', 'environment']),
    transport: EmailTransportKind,
    host: z.string(),
    port: z.number().int(),
    security: EmailSecurity,
    username: z.string(),
    passwordSet: z.boolean(),
    allowInsecureAuth: z.boolean(),
    fromName: z.string(),
    fromAddress: z.string(),
    replyTo: z.string(),
    /** i18n keys of warnings about the saved settings (for example plain-text sign-in). */
    warnings: z.array(z.string()),
    updatedAt: IsoDateTime.nullable(),
});
export const EmailServerUpdate = z.object({
    transport: EmailTransportKind,
    host: z.string().trim().max(253).default(''),
    port: z.number().int().min(1).max(65535).default(587),
    security: EmailSecurity.default('starttls'),
    username: z.string().trim().max(254).default(''),
    /** Empty or missing keeps the saved password. */
    password: z.string().max(512).optional(),
    /** Removes the saved password (only when `password` is empty). */
    clearPassword: z.boolean().default(false),
    allowInsecureAuth: z.boolean().default(false),
    fromName: z.string().trim().min(1).max(80),
    fromAddress: Email,
    replyTo: z.union([z.literal(''), Email]).default(''),
});
export const EmailServerTest = z.object({ to: Email });
export const EmailServerTestResult = z.object({
    ok: z.boolean(),
    /** The mail server's error text with secrets removed. Null when ok. */
    error: z.string().nullable(),
});
//# sourceMappingURL=email-server.js.map